import { LinkAuthMethodStrategy } from './link-auth-method-strategy.inteface';
import { AuthMethod } from '../../../account-window/parts/auth-method';
import { HubApi } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api';
import {
    LinkAuthMethodFbRequest,
    LinkAuthMethodFbResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/link-auth-method-fb.protocol';

export class LinkAuthMethodFbStrategy implements LinkAuthMethodStrategy {
    static authMethod = AuthMethod.FB;
    constructor(private hubApi: HubApi) {}

    link(deviceId: string, params: LinkAuthMethodFbRequest): Promise<LinkAuthMethodFbResponse> {
        return this.hubApi.linkAuthMethodFb(deviceId, params);
    }
}
